// extracted by mini-css-extract-plugin
export var askAiIcon = "_m3-j";
export var category = "_m3-9";
export var categoryHeader = "_m3-e";
export var container = "_m3-0";
export var group = "_m3-a";
export var groupItems = "_m3-f";
export var groupSeparator = "_m3-k";
export var loading = "_m3-1";
export var noResults = "_m3-3";
export var placeholder = "_m3-2";
export var resultContent = "_m3-5";
export var resultIcon = "_m3-c";
export var resultItem = "_m3-g";
export var resultMeta = "_m3-8";
export var resultSubtitle = "_m3-7";
export var resultSuffix = "_m3-i";
export var resultTitle = "_m3-6";
export var resultsList = "_m3-4";
export var searchGroup = "_m3-d";
export var selected = "_m3-h";
export var subgroup = "_m3-b";